import { LocalizationManager } from "../../localization/localization_manager.js";
import { OFFLINE_ADS_TOOLTIP_KEY } from "../../ads/offline_ads.js";
import { UIElement } from "../common_ui_elements/ui_element.js";
import { AnchoredTooltip } from "./anchored_tooltip.js";

/** Owner tag, so hiding the ad tooltip never closes a reward tooltip on the same screen. */
const AD_TOOLTIP_OWNER = "ads";

export const ADS_UNAVAILABLE_TOOLTIP_KEY = 'ADS.UNAVAILABLE.TRY_LATER';

export function showOfflineAdTooltip( anchor: UIElement ): void
{
  showAdTooltip( anchor, OFFLINE_ADS_TOOLTIP_KEY );
}

export function showAdUnavailableTooltip( anchor: UIElement ): void
{
  showAdTooltip( anchor, ADS_UNAVAILABLE_TOOLTIP_KEY );
}

function showAdTooltip( anchor: UIElement, text_key: string ): void
{
  AnchoredTooltip.show( anchor, { text: LocalizationManager.t( text_key ) }, AD_TOOLTIP_OWNER );
}

export function hideOfflineAdTooltip(): void
{
  AnchoredTooltip.hide( AD_TOOLTIP_OWNER );
}
